// extracted by mini-css-extract-plugin
export default {"block":"OverlayLoading_block__fHGHn"};